import {pt} from 'oss-core-kotlin-common-js';

const {
  Country,
  PeculiarCountry,
  MemberState,
} = pt.at.oss.kotlin.core.enumeration;

export interface KotlinCatalog { codeA2: string, labelPT: string, labelEN: string }
export interface KotlinCountry extends KotlinCatalog { isInEU: boolean }
export interface KotlinPeculiarCountry extends KotlinCatalog { isUnion: boolean, isNonUnion: boolean, parentA2: string }

export interface KotlinMemberState { ueCode: string, n3Code: string, a2Code: string }

const allCountries: Array<KotlinCountry> = Country.values();

export const euCountries: Array<KotlinCountry> = allCountries.filter(c => c.isInEU);
export const nonEuCountries: Array<KotlinCountry> = allCountries.filter(c => !c.isInEU);
export const euCountriesExceptPt: Array<KotlinCountry> = euCountries.filter(c => c !== Country.PORTUGAL);
export const onlyPtCountryList: Array<KotlinCountry> = [Country.PORTUGAL];


export const peculiarCountries: Array<KotlinPeculiarCountry> = PeculiarCountry.values();
export const artificialCodeAddress = PeculiarCountry.Companion.ARTIFICIAL_CODE_ADDRESS.toArray();


export const memberStates: Array<KotlinCatalog> =
  MemberState.values().map(ms => {
    //[OSS-1552][OSS-1609] Usamos ms.ueCode dado que Country.GREECE.a2Code é EL em vez de GR
    const ctr = euCountries.find(country => country.codeA2 == ms.ueCode)
    return {
      codeA2: ms.ueCode,
      labelPT: ctr.labelPT,
      labelEN: ctr.labelEN,
    }
  });
export const memberStatesExceptPt: Array<KotlinCatalog> = memberStates.filter(ms => ms.codeA2 !== Country.PORTUGAL.codeA2);
